import { Record } from "immutable";

import createFromJS from "../../createFromJS";

export const PrintingTableCellRecord = Record({
  row: 75,
  column: 5,
  cellType: null,
  columnId: null,
  rowId: null,
  colOptions: null,
  value: null,
  top: 0,
  left: 0,
  height: 0,
  width: 0
});
const data = {
  objects: {
    colOptions: "Map"
  }
};

createFromJS.registerCallback(
  "PrintingTableCellRecord",
  createFromJS.createPrimitiveCallback(PrintingTableCellRecord, data)
);
